module.exports = __webpack_public_path__ + "static/media/envelope-open-text.718a9938.svg";